import { type V1FileState } from 'my-recruiter-app-ts-if'
import type React from 'react'
import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useState
} from 'react'

interface ComposeMessageContextType {
  listFile: string[]
  setListFile: Dispatch<SetStateAction<string[]>>
  isEdit: boolean
  setIsEdit: Dispatch<SetStateAction<boolean>>
  listFileState: V1FileState[]
  setListFileState: Dispatch<SetStateAction<V1FileState[]>>
}

export const ComposeMessageContext = createContext<ComposeMessageContextType>({
  listFile: [],
  setListFile: () => {},
  isEdit: true,
  setIsEdit: () => {},
  listFileState: [],
  setListFileState: () => {}
})

export const ComposeMessageContextProvider = ({
  children
}: {
  children: React.ReactNode
}): JSX.Element => {
  const [listFile, setListFile] = useState<string[]>([])
  const [isEdit, setIsEdit] = useState<boolean>(true)
  const [listFileState, setListFileState] = useState<V1FileState[]>([])

  return (
    <ComposeMessageContext.Provider
      value={{
        listFile,
        setListFile,
        isEdit,
        setIsEdit,
        listFileState,
        setListFileState
      }}
    >
      {children}
    </ComposeMessageContext.Provider>
  )
}
